import { useAppForm } from "@/hooks/form";
import { useMollie } from "@/lib/mollie/hooks";
import { m } from "@/paraglide/messages";
import { Button } from "@bidbattles/bloks/components/ui/button";
import { useFormContext } from "@bidbattles/bloks/hooks/form-context";
import { cn } from "@bidbattles/bloks/lib/ui";
import { toast } from "sonner";

export type MolliePaymentParams = { method: "creditcard"; token: string };
export type PaymentFormProps = {
	onSubmitSuccess: (params: MolliePaymentParams) => Promise<unknown>;
	className?: string;
	submitLabel?: string;
} & (
	| { cancellable: false }
	| { cancellable: true; onCancel: () => void; cancelLabel?: string }
);

export function MolliePaymentForm(props: PaymentFormProps) {
	// const mollie = useMollie();
	const form = useAppForm({
		defaultValues: {
			cardNumber: "",
			cardHolder: "",
			expiryDate: "",
			verificationCode: "",
		},
		async onSubmit() {
			// const tokenResult = await mollie.createToken();
			// if (!tokenResult.ok) {
			// 	toast.error(m.error_toast({ message: tokenResult.error.message }));
			// 	return;
			// }

			await props.onSubmitSuccess({
				method: "creditcard",
				token: "",
			});
		},
	});

	return (
		<form
			className={cn("flex flex-col gap-6", props.className)}
			onSubmit={(e) => {
				e.preventDefault();
				e.stopPropagation();
				form.handleSubmit(e);
			}}
		>
			{/*
			<div className="flex flex-col gap-2">
				<form.AppField name="cardNumber">
					{(field) => <field.CardNumber />}
				</form.AppField>
				<form.AppField name="cardHolder">
					{(field) => <field.CardHolder />}
				</form.AppField>
				<div className="flex gap-2">
					<form.AppField name="expiryDate">
						{(field) => <field.ExpiryDate />}
					</form.AppField>
					<form.AppField name="verificationCode">
						{(field) => <field.VerificationCode />}
					</form.AppField>
				</div>
			</div>*/}
			<form.AppForm>
				<div className="flex flex-col gap-4">
					<form.SubscribeButton
						label={props.submitLabel ?? "Pay with Mollie"}
					/>
					{props.cancellable && (
						<CancelButton onClick={props.onCancel} label={props.cancelLabel} />
					)}
				</div>
			</form.AppForm>
		</form>
	);
}

function CancelButton({
	label,
	onClick,
}: { label?: string; onClick: () => void }) {
	const form = useFormContext();

	return (
		<form.Subscribe selector={(state) => state.isSubmitting}>
			{(isSubmitting) => (
				<Button variant="outline" disabled={isSubmitting} onClick={onClick}>
					{label ?? "Cancel"}
				</Button>
			)}
		</form.Subscribe>
	);
}
